import { Box, Toolbar } from "@mui/material";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useState, useRef } from "react";

export default function LayoutWrapper({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const handleDrawerToggle = () => setMobileOpen((v) => !v);
  const menuButtonRef = useRef(null)

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        minHeight: "100vh",
        overflowX: "hidden",
        bgcolor: (t) => t.palette.background.default,
      }}
    >
      <Navbar handleDrawerToggle={handleDrawerToggle} menuButtonRef={menuButtonRef} />
      <Sidebar open={mobileOpen} handleDrawerToggle={handleDrawerToggle} returnFocusRef={menuButtonRef} />

      {/* Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // Smaller padding on phones, comfy on larger screens
          p: { xs: 2, sm: 3 },
          // Ensure content doesn’t hide under the AppBar
          // Toolbar adds the right top offset
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Toolbar />
        {/* Optional max width for nicer reading on wide screens */}
        <Box sx={{ width: "100%" }}>{children}</Box> 
      </Box>
    </Box>
  );
}